<template>
    <el-menu-item
        v-if="!item.subMenu && item.routerPath"
        :index="item.routerPath"
        class="menu-item-layout"
        :class="{
            'fa-icon-pad-left': item.routerPath === '/oms/cms'
        }"

    >
        <img :src="item.icon" v-if="(item.subMenu && item.subMenu.length <= 0) || item.isSpecial" />
        <img :src="require('@/assets/nav/dot.svg')" v-else />
        <span style="margin-left:15px" slot="title">{{ item.label }}</span>
    </el-menu-item>
    <el-submenu v-else :index="item.routerPath" :popper-append-to-body="false">
        <template slot="title">
            <img :src="item.icon" class="sub-icon" width="16px" />
            <span style="margin-left:15px" slot="title">{{ item.label }}</span>
        </template>
        <SubMenu
            v-for="(sub, index) in item.subMenu"
            :key="index"
            :item="sub"
        />

    </el-submenu>
</template>

<script>
import SubMenu from '@/components/navMenu/SubMenu.vue'
export default {
    name: 'SubMenu',
    components: {
        SubMenu
    },
    props: {
        item: {
            type: Object,
            require: true
        }
    },
    emits: ['handleCollapseMenu']
}
</script>
<style lang="scss" scoped>
::v-deep .el-menu {
    &--popup {
        overflow: auto;
        max-height: 300px;
    }
}
</style>
